/**
 * Reach & Frequency family (including variants like Ad Fatigue Reach & Frequency)
 * is the exception: cadence + fiscal calendar.
 * All other report types (Age & Gender, DMA, SKU, and any future types)
 * default to breakdown behavior.
 */
const normalizeReportType = (reportType: string): string =>
  reportType
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/\s+/g, '_')
    .replace(/-/g, '_');

export const isReachAndFrequencyReport = (reportType: string | null | undefined): boolean => {
  if (!reportType) return false;
  const normalized = normalizeReportType(reportType);
  return normalized === 'reach_and_frequency' || normalized.includes('reach_and_frequency');
};

export const isBreakdownReport = (reportType: string | null | undefined): boolean => {
  if (!reportType) return false;
  return !isReachAndFrequencyReport(reportType);
};
